export default __webpack_public_path__ + "static/media/news27.9b08d5fc.jpg";